import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import AnimalDetail from "@/pages/AnimalDetail";
import Login from "@/pages/Login";
import NewPost from "@/pages/NewPost";
import AdminUsers from "@/pages/AdminUsers";
import About from "@/pages/About";
import GetInvolved from "@/pages/GetInvolved";
import Clubs from "@/pages/Clubs";
import Education from "@/pages/Education";
import Qa from "@/pages/Qa";
import AuthCallback from "@/pages/AuthCallback";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/animal/:id" element={<AnimalDetail />} />
      <Route path="/login" element={<Login />} />
      <Route path="/new" element={<NewPost />} />
      <Route path="/edit/:id" element={<NewPost />} />
      <Route path="/admin/users" element={<AdminUsers />} />
      <Route path="/about" element={<About />} />
      <Route path="/get-involved" element={<GetInvolved />} />
      <Route path="/clubs" element={<Clubs />} />
      <Route path="/education" element={<Education />} />
      <Route path="/qa" element={<Qa />} />
      <Route path="*" element={<Home />} />
    </Routes>
  );
}

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, duration: 1.1 }}>
      <div className="App">
        <BrowserRouter>
          <AuthProvider>
            <AppRouter />
            <Toaster position="bottom-right" toastOptions={{ style: { borderRadius: 0 } }} />
            <div className="grain-overlay" aria-hidden="true" />
          </AuthProvider>
        </BrowserRouter>
      </div>
    </ReactLenis>
  );
}

export default App;
